/*=========================================================================================
  File Name: moduleDashboardState.js
  Description: Dashboard Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

    countOfTotalChannel: 0,
    countOfActiveChannel: 0,
    countOfErrorChannel: 0,

    countOfTotalDashcam: 0,
    countOfActivatedDashcam: 0,

    countOfTotalUser: 0,
    countOfSubscriptionYUser: 0,

    wowzaDailyReportSeries: [],
    sumOfThisMonthWowzaTotalUsage: 0,
    sumOfPreviousMonthWowzaTotalUsage: 0,
}